<template>
  <div class="container pt-md-5 pt-3 content" v-if="postData">
    <loading :active.sync="isLoading"></loading>
    <div>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <a :href="'/' + courseId">
          <span class="material-icons align-bottom">keyboard_arrow_left</span> 回公告頁
        </a>
      </div>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3 class="mb-0">{{ postData.name }}</h3>
        <span
          class="badge badge-light text-muted px-4 py-2 font-weight-normal d-none d-md-inline-block"
          style="font-size: 14px"
        >{{ chapterName }}</span>
      </div>
      <p class="text-muted">{{ postData.date }}</p>
      <videoPlayer v-if="postData.video_url && postData.video_url !== ''" :video-data="postData"></videoPlayer>
      <audioPlayer v-if="postData.audio_url && postData.audio_url !== ''" :audio-data="postData"></audioPlayer>
      <div class="row no-gutters justify-content-center course-content mb-5">
        <div class="col-md-10">
          <courseContent :content="postData.content"></courseContent>
        </div>
      </div>
      <comment :post-name="postData.name" :admin-auth="adminAuth" :user-pic="loginUserPic" :user-id="loginUserId" :scope="postId" entity="Posts" />
    </div>
    <a class="mr-0 d-md-none d-inline-block position-fixed change-font-btn" href="#" @click.prevent="changeFontModal = true">
      <span class="material-icons fa-video-library"> format_size </span>
    </a>
    <bottom-modal v-if="changeFontModal"></bottom-modal>
  </div>
</template>
<script>
import videoPlayer from "./../components/VideoPlayer";
import audioPlayer from "./../components/AudioPlayer";
import courseContent from "./../components/CourseContent";
export default {
  name: "PostDetail",
  props: {
    courseId: String,
    chapterId: String,
    postPathVar: String,
    postId: String,
    chapterName: String,
    loginUserId: String,
    loginUserPic: String,
    adminAuth: String, // 確認是否有 Admin 權限（可刪除所有人的留言）
  },
  components: {
    videoPlayer,
    audioPlayer,
    courseContent,
  },
  data() {
    return {
      postData: {},
      isLoading: true,
      courseData: {},
      allPosts: [],
      changeFontModal: false
    };
  },
  watch: {
    changeFontModal (val) {
      val? $('body').addClass('overflow-hidden') : $('body').removeClass('overflow-hidden')
    }
  },
  methods: {
    getPostDetail() {
      const vm = this;
      vm.isLoading = true;
      if (this.courseId === "community") {
        axios
          .get(`/api/community/chapter/${vm.chapterId}/post/${vm.postPathVar}`)
          .then((res) => {
            vm.postData = res.data.data;
            vm.isLoading = false;
          })
          .catch((err) => {
            vm.isLoading = false;
            flash("讀取錯誤" + err, "danger");
          });
      } else {
        axios
          .get(`/api/school/chapter/${vm.chapterId}/post/${vm.postPathVar}`)
          .then((res) => {
            vm.postData = res.data.data;
            vm.isLoading = false;
          })
          .catch((err) => {
            vm.isLoading = false;
            flash("讀取錯誤" + err, "danger");
          });
      }
    },
    getCourse() {
      const vm = this;
      axios.get(`/api/${vm.courseId}`).then((res) => {
        vm.courseData = res.data.data;
        res.data.data.chapters.forEach((chapter) => {
          chapter.posts.forEach((post) => {
            vm.allPosts.push({ ...post, chapterVar: chapter.path_var });
          });
        });
      });
    },
  },
  computed: {
  },
  mounted() {
    const vm = this;
    vm.getPostDetail();
    vm.getCourse();
    vm.$bus.$on('changeFontModalShow', (val) => {
      vm.changeFontModal = val;
    });
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .md-fixed-botoom .course-content {
    margin-bottom: 68px;
  }
}
.completedBtn {
  width: 240px;
  max-width: 240px;
}
@media (max-width: 768px) {
  .completedBtn {
    width: 100%;
    max-width: 100%;
  }
  .btn-w-100 {
    width: 100%;
    max-width: 100%;
  }
}
.change-font-btn {
  right: 15px;
  top: 14px;
  z-index: 1080;
}
.modal-open  .change-font-btn, .sidebar-open .change-font-btn {
  display: none !important;
}
</style>
